/**
 * @internalapi
 */
export class P2PPairingRequest {
    type = 'p2p-pairing-request';
    relayServer;
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, relayServer, icon, appUrl) {
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
        this.relayServer = relayServer;
    }
}
/**
 * @internalapi
 */
export class ExtendedP2PPairingRequest extends P2PPairingRequest {
    senderId;
    constructor(id, name, publicKey, version, relayServer, senderId, icon, appUrl) {
        super(id, name, publicKey, version, relayServer, icon, appUrl);
        this.senderId = senderId;
    }
}
//# sourceMappingURL=P2PPairingRequest.js.map